export function formatSubscriptionDateForDisplay(raw: string): string {
  const s = raw.trim();
  if (!s) return s;

  const ymdMatch = /^(\d{4})-(\d{2})-(\d{2})(?:$|[Tt\s].*)/.exec(s);
  if (ymdMatch) {
    const y = Number(ymdMatch[1]);
    const mo = Number(ymdMatch[2]);
    const d = Number(ymdMatch[3]);
    const date = new Date(Date.UTC(y, mo - 1, d));
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "UTC",
    });
  }

  const t = Date.parse(s);
  if (!Number.isNaN(t)) {
    return new Date(t).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return s;
}

export function formatPrice(n: number): string {
  return n.toFixed(2).replace(/\.00$/, "");
}

/**
 * Percentage to show on the discount pill, or null when there's no active discount.
 * Uses the discount's own percentage when there's exactly one (avoids rounding drift);
 * otherwise derives the effective percentage from the original vs net price.
 */
export function discountPillPercent(
  discounts: { percentage?: number | null }[] | null | undefined,
  original: number | null | undefined,
  discounted: number | null | undefined,
): number | null {
  if (
    original == null ||
    discounted == null ||
    !Number.isFinite(original) ||
    !Number.isFinite(discounted) ||
    original <= 0 ||
    discounted >= original
  ) {
    return null;
  }
  const list = discounts ?? [];
  if (list.length === 1 && list[0]?.percentage != null) {
    return Math.round(list[0].percentage);
  }
  return Math.round(((original - discounted) / original) * 100);
}

export function parsePrice(
  price?: string | number | null,
  discounted?: number | null,
): { display: number | null; original: number | null } {
  const orig =
    price != null
      ? typeof price === "number"
        ? price
        : parseFloat(String(price))
      : null;
  const disc = discounted != null ? Number(discounted) : null;
  if (orig != null && !Number.isFinite(orig))
    return { display: null, original: null };
  if (disc != null && !Number.isFinite(disc))
    return { display: orig, original: orig };
  return {
    display: disc ?? orig,
    original: orig,
  };
}
